var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 61,
    viewBox: "0 0 310 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68254 17.2618C3.65199 14.7274 8.52467 8.59812 5.68254 6.32861C3.97055 4.96153 1.4138 9.27624 1.4138 9.27624C-5.66282 22.6947 14.7768 27.6624 41.5647 24.7122C91.9234 19.1661 198.771 6.44664 294.534 7.43356C294.534 7.43356 73.9681 24.3124 83.7571 52.8287C89.3006 68.9774 190.688 40.3656 169.998 52.3987C164.218 55.7603 159.55 55.7708 153.047 58.7257C137.077 65.9822 191.936 53.9958 193.383 48.9588C197.46 34.7691 93.0988 55.1629 90.7479 52.153C79.6117 34.3277 310 14.5594 310 9.27619C310 -20.1497 16.7565 31.0833 5.68254 17.2618Z",
    fill: "#F74F68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.9bb83be8e7258fadcbeff951ba6140d0.svg";
export { ForwardRef as ReactComponent };